import { supabase } from '../supabaseClient';

/**
 * Active members of the given groups, with the profile fields the Find picker
 * shows. One query for every group the user is in, so the picker can list
 * people across groups and the card can say how many of the subscribed
 * group's members are sharing. Membership only — never positions.
 */
export async function fetchMembersForGroups(groupIds) {
  const ids = (groupIds ?? []).filter(Boolean);
  if (ids.length === 0) return [];
  const { data, error } = await supabase
    .from('group_members')
    .select(
      'group_id, user_id, profiles!group_members_user_id_fkey(display_name, profile_photo_url)',
    )
    .in('group_id', ids)
    .is('left_at', null)
    .eq('removed', false);
  if (error) throw error;
  return (data ?? []).map((row) => {
    const profile = Array.isArray(row.profiles) ? row.profiles[0] : row.profiles;
    return {
      groupId: row.group_id,
      userId: row.user_id,
      displayName: profile?.display_name?.trim() || 'Group member',
      photoUrl: profile?.profile_photo_url ?? null,
    };
  });
}
